import { Router } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { DependentService } from '../../services/dependent.service';
import { NotificationService } from '../../notification/swal/notification.service';
import { DefaultersModel, PedidosModel } from './defaulters.model';
import { MaskHelper } from '../../helpers/mask';
import { InfiniteDetaiListModel } from '../infinite-scroll-list/infiniteList.model';

@Component({
  selector: 'app-defaulters',
  templateUrl: './defaulters.component.html',
  styleUrls: ['./defaulters.component.less']
})
export class DefaultersComponent implements OnInit {

  defaulters: DefaultersModel = new DefaultersModel();

  constructor(private router: Router, private dependentService: DependentService, private notificationService: NotificationService) { }

  ngOnInit() {
    this.dependentService.buscarPedidosEmAberto()
      .then((_pedidos: PedidosModel[]) => {
        this.defaulters.pedidos = _pedidos;
        this.formatPedidos();
      })
      .catch((err) => {
        this.notificationService.showErrorNotification(err.message);
      });
  }

  private formatPedidos() {
    const _pedidos = this.defaulters.pedidos.map(pedido => {
      const _pedido = new PedidosModel();
      _pedido.Id = pedido.Id;
      _pedido.Valor = pedido.Valor;
      _pedido.Date = this.convertToUTCDate(pedido.Date);
      _pedido.Produtos = pedido.Produtos;
      _pedido.PedidoPodeSerPagoComSaldo = pedido.PedidoPodeSerPagoComSaldo;
      _pedido.MostraDetalhes = false;
      _pedido.CartaoCashlessId = pedido.CartaoCashlessId;
      return _pedido;
    });
    this.defaulters.pedidos = _pedidos;
  }

  show(id: string) {
    this.changeChildOpenStatus(id, true);
  }

  openChildDetail(id: string) {
    this.changeChildOpenStatus(id, true);
  }

  closeChildDetal(id: string) {
    this.changeChildOpenStatus(id, false);
  }

  private changeChildOpenStatus(id: string, status: boolean) {
    const child = this.defaulters.pedidos.find(_child => {
      return _child.Id === id;
    });
    child.MostraDetalhes = status;
  }

  formatLocalDate(date: string) {
    return MaskHelper.formatDate(date);
  }

  private convertToUTCDate(datetoConvert: Date): Date {
    const date = new Date(datetoConvert);
    const userTimezoneOffset = date.getTimezoneOffset() * 60000;
    return new Date(date.getTime() - userTimezoneOffset);
  }

  payWithBalance(id) {
    const pedido = this.defaulters.pedidos.find(_pedido => _pedido.Id === id);
    this.dependentService.debitFromBalance(pedido.Id)
    .then(() => {
      this.notificationService.showSuccessNotification('Débito pago com sucesso!');
      this.defaulters.pedidos = [];
      this.ngOnInit();
    })
    .catch((err) => {
      this.notificationService.showErrorNotification(err.message);
    });

  }

  payWithCreditCard(id, idDependent) {
    this.router.navigate([`general/debito/${id}/${idDependent}`]);
  }

}




// WEBPACK FOOTER //
// /usr/src/app/src/app/components/defaulters/defaulters.component.ts